<template>
    <div>
        <div v-show="showTap === 1">
            <HomePage></HomePage>
        </div>
        <div v-show="showTap === 2">
            <TrafficIndex :val="result"></TrafficIndex>
        </div>
    </div>
</template>

<script>
import headLine from "../components/headline"
import HomePage from "./homePage.vue"
import TrafficIndex from "./trafficIndex.vue"
export default {
    components: {
        headLine,
        HomePage,
        TrafficIndex,
    },
    data() {
        return {
            showTap: 1,
            result: {},
        }
    },
    methods: {
        val: function (val) {
            this.result = JSON.parse(JSON.stringify(val))
            if (val.code == 200) {
                this.choicePath(2)
            }
        },
        choicePath(num) {
            if (num === 1) {
                $(".title1-2").css({
                    borderBottom: "2px solid #0000FF",
                })
                $(".title1-3").css({
                    borderBottom: "none",
                })
                this.showTap = 1
            } else {
                $(".title1-3").css({
                    borderBottom: "2px solid #0000FF",
                })
                $(".title1-2").css({
                    borderBottom: "none",
                })
                this.showTap = 2
            }
        },
    },
}
</script>

<style lang="less" scoped>
.title1-1 {
    width: 100%;
    display: flex;
    background-color: #eeeeee;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
}

.title1-2 {
    border-bottom: 2px solid #0000ff;
    margin: 0 20px;
}

.title1-3 {
}
</style>
